'use strict';

module.exports = {
  date: {
    titleFormat: 'dddd, MMMM D, YYYY',
    calendarMinThreshold: 10,
  },
  picker: {
    listMaxThreshold: 4,
  },
};
